import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  accessToken: undefined,
  refreshAccessToken: undefined,
  user: undefined,
  permissions: [],
  permissionsFetched: false,
  locale: "nl",
};

const sessionSlice = createSlice({
  name: "session",
  initialState,
  reducers: {
    setAccessToken: (state, action) => {
      state.accessToken = action.payload;
    },
    setPermissions: (state, action) => {
      state.permissions = action.payload;
    },
    setPermissionsFetched: (state) => {
      state.permissionsFetched = true;
    },
    setRefreshAccessToken(state, action) {
      state.refreshAccessToken = action.payload;
    },
    clearRefreshAccessToken(state) {
      state.refreshAccessToken = undefined;
    },
    setCurrentUser(state, action) {
      state.user = action.payload;
    },
    clearCurrentUser(state) {
      state.user = undefined;
    },
    sessionDestroy(state) {
      state.accessToken = undefined;
      state.user = undefined;
      state.refreshAccessToken = undefined;
    },
    setLocale: (state, action) => {
      state.locale = action.payload;
    },
  },
});

export const {
  setAccessToken,
  setRefreshAccessToken,
  clearRefreshAccessToken,
  setCurrentUser,
  clearCurrentUser,
  setPermissions,
  setPermissionsFetched,
  sessionDestroy,
  setLocale,
} = sessionSlice.actions;

export default sessionSlice.reducer;
